module.exports = __webpack_public_path__ + "static/media/work1.d0bcd234.png";